import React, {useEffect, useState} from 'react'
import Header from '../../components/Header'
import Search from '../../components/Search'
import {CategoryDTO} from "../../dtos/category.dto";
import {useNavigate} from "react-router";
import {useRecoilValue} from "recoil";
import {fetchAPIResponseSelector} from "../../store/user.atom";
import {toast} from "react-toastify";
import {IngredientDTO} from "../../dtos/ingredient.dto";

type Props = {}

const Ingredients = (props: Props) => {
    const [search, setSearch] = useState('');
    const [ingredients, setIngredients] = useState<IngredientDTO[]>([]);
    const navigate = useNavigate();
    const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);

    const fetchIngredients = async () => {
        const ingredients = await fetchAPIResponse<IngredientDTO[]>(`/ingredients?search=${search}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        });

        setIngredients(ingredients.data);
    }

    useEffect(() => {
        fetchIngredients();
    }, []);

    useEffect(() => {
        fetchIngredients();
    }, [search]);

    const handleEdit = (categoryId: any) => {
        navigate(`/ingredients/edit/${categoryId}`);
    };

    const handleDelete = async (categoryId: any) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this category?');
        if (confirmDelete) {
            try {
                await fetchAPIResponse(`/ingredients/${categoryId}`, {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json'
                    }
                });

                fetchIngredients();
            } catch (error) {
                toast.error((error as Error).message);
            }
        }
    };

  return (
    <div className='flex flex-col items-center w-full h-full overflow-auto py-10 gap-6'>
      <Header title={'Ingredients'} button={true} buttonTitle={'Add ingredients'} action={'/ingredients/add'}/>
      <div className="zbh-card w-11/12 p-8">
        <Search search={search} setSearch={setSearch} placeholderText={'Ingredient'}/>
        <div className='w-full mt-3'>
              <div className='grid grid-cols-12 gap-4 px-2'>
                <div className="zbh-th col-span-7">Name</div>
                <div className="zbh-th col-span-2">Price</div>
                <div className="zbh-th col-span-3 text-right">Actions</div>
              </div>
              <div className="zbh-tear mt-2" />
              {ingredients.map((item) => (
                <div key={item.id} className='grid grid-cols-12 items-center gap-4 px-2 py-3 border-b border-hair last:border-0 transition hover:bg-canvas/60 rounded-lg'>
                  <div className='col-span-7 min-w-0'>
                    <p className='truncate text-sm font-medium text-ink'>{item.name}</p>
                  </div>
                  <div className='col-span-2'>
                    <span className='zbh-figure text-sm font-bold text-ink'>${item.base_price}</span>
                  </div>
                  <div className='col-span-3 flex items-center justify-end gap-2'>
                    <button onClick={() => handleEdit(item.id)} className='zbh-btn-ghost px-4 py-1.5 text-xs'>Edit</button>
                    <button onClick={() => handleDelete(item.id)} className='zbh-btn-danger px-4 py-1.5 text-xs'>Delete</button>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  )
}

export default Ingredients
